import { useState, useEffect } from 'react';
import api from '../config/axiosConfig';

// La versión de CONEM vive solo en backend/pom.xml; el frontend la consulta, nunca la guarda.
let versionRequest = null;

const useConemVersion = () => {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    if (!versionRequest) {
      versionRequest = api.get('/version')
        .then(res => res.data.version)
        .catch(() => {
          versionRequest = null;
          return null;
        });
    }
    let active = true;
    versionRequest.then(v => { if (active) setVersion(v); });
    return () => { active = false; };
  }, []);

  return version;
};

export default useConemVersion;
